import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { chipsStyles, OptionsWrapper } from '../styled';
import {
  BUILDING_TYPE_ID,
  FORM_VALUES
} from '../../../../../utils/helpers/constants';
import { ItemBuildingTypeEnum } from '../../../../../graphql/types';
import { Chips } from '../../../../ui/Chips';
import { FormErrorField } from '../FormErrorField';

const newOrSecondaryEstate = [
  {
    value: BUILDING_TYPE_ID.FLAT_NEW,
    name: 'new_search.new_building',
    id: 'item-form-new-building'
  },
  {
    value: BUILDING_TYPE_ID.FLAT_SECONDARY,
    name: 'new_search.secondary_building',
    id: 'item-form-second-hand-building'
  }
];

const buildingType = [
  {
    value: ItemBuildingTypeEnum.BusinessCenter,
    id: 'item-form-business-center',
    name: 'search.form.building_type_group.business'
  },
  {
    value: ItemBuildingTypeEnum.Apartment,
    id: 'item-form-house-flat',
    name: 'search.form.building_type_group.apartment'
  },
  {
    value: ItemBuildingTypeEnum.Villa,
    id: 'item-form-villa-building',
    name: 'search.form.building_type_group.villa'
  }
];

interface BuildingTypeProps {
  isFlat?: boolean;
}

export const BuildingType: React.FC<BuildingTypeProps> = ({ isFlat }) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();

  const selectedValue = isFlat
    ? values[FORM_VALUES.categoryId]
    : values[FORM_VALUES.buildingType];

  const onClick = (id: string) => {
    const fieldToUpdate = isFlat
      ? FORM_VALUES.categoryId
      : FORM_VALUES.buildingType;

    change(fieldToUpdate, id);
  };

  return (
    <div>
      <OptionsWrapper>
        {(isFlat ? newOrSecondaryEstate : buildingType).map(building => (
          <Chips
            text={t(building.name).replace(' / ', '/')}
            value={building.value}
            type="button"
            hasCustomOnChange
            key={building.id}
            storedValue={selectedValue}
            onClick={() => onClick(building.value)}
            styles={chipsStyles}
            stat={building.id}
            cypress={building.id}
            isTextPadding={false}
          />
        ))}
      </OptionsWrapper>

      {!isFlat && (
        <FormErrorField
          field={FORM_VALUES.buildingType}
          cypress="building-type-field-error"
        />
      )}
    </div>
  );
};
